<template>
  <div class="file-evaluation">
    <div class="file-evaluation__task" v-html="evaluation.task"></div>
    <section v-if="isSubmitted" class="file-evaluation__success" role="status">
      <span><v-icon color="#168565" size="26">mdi-check-circle-outline</v-icon></span>
      <div>
        <strong>Роботу надіслано</strong>
        <small>Файл успішно передано на перевірку вчителю.</small>
      </div>
    </section>
    <section v-else class="file-evaluation__upload">
      <div class="file-evaluation__upload-head">
        <span><v-icon size="24">mdi-paperclip</v-icon></span>
        <div>
          <strong>Додайте виконану роботу</strong>
          <small>Фото, документ, аудіо або інший дозволений файл</small>
        </div>
      </div>
      <v-file-input
        v-model="files"
        class="file-evaluation__input"
        outlined
        dense
        show-size
        chips
        multiple
        prepend-icon=""
        :rules="rules"
        :loading="false"
        label="Обрати файли"
        accept="image/jpeg,image/png,image/jpg,audio/mpeg,audio/mp3,audio/wav,audio/ogg,audio/aac,.aac,.mp3,.wav,.ogg,.m4a,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.xml,.txt"
        @click="checkConnection"
      />
      <small class="file-evaluation__hint">До 10 МБ кожен файл</small>
      <span v-if="errorMessage" class="file-evaluation__error">{{ errorMessage }}</span>
    </section>
    <button
      v-if="!isSubmitted"
      class="file-evaluation__submit"
      type="button"
      :disabled="!canSubmit"
      @click="sendAnswer"
    >
      Надіслати на перевірку
      <v-icon size="19">mdi-send</v-icon>
    </button>
  </div>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';
const ERROR_MESSAGE = 'Розмір файлу має бути менше 10 MB!';
const ERROR_MESSAGE_OFFLINE = "Немає з'єднання з мережею, спробуйте пізніше";

export default {
  name: 'AddFileEvaluation',
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: [],
      errorMessage: '',
      rules: [
        (value) => {
          return (
            !value || !value.size || value.size < 10000000 || ERROR_MESSAGE
          );
        },
      ],
    };
  },
  watch: {
    evaluation(evaluation) {
      this.files = evaluation.answer || [];
    },
  },

  computed: {
    canSubmit() {
      return this.files.length > 0 && this.files.every((file) => (
        file.size && this.rules.every((rule) => typeof rule(file) !== 'string')
      ));
    },
  },

  methods: {
    sendAnswer() {
      const isValid = this.files.every((file) => {
        return (
          file.size &&
          this.rules.every((rule) => {
            return typeof rule(file) !== 'string';
          })
        );
      });
      if (!isValid) {
        this.$emit('evaluateEvent', {
          type: evaluationEventEnum.SHOW_TOASTER,
          data: {
            text: ERROR_MESSAGE,
          },
        });
        return;
      }
      this.$emit('evaluateEvent', {
        type: evaluationEventEnum.SEND_ANSWER,
        data: {
          answer: this.files,
        },
      });
    },

    checkConnection(e) {
      if (!navigator.onLine) {
        e.preventDefault();
        this.$emit('evaluateEvent', {
          type: evaluationEventEnum.SHOW_TOASTER,
          data: {
            text: ERROR_MESSAGE_OFFLINE,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.file-evaluation { color: #344054; }
.file-evaluation__task {
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.55;
  margin-bottom: 24px;
}
.file-evaluation__task::v-deep p { margin: 0 0 8px; }
.file-evaluation__task::v-deep * {
  color: var(--theme-banner-text) !important;
}
.file-evaluation__upload {
  background: var(--theme-surface-decorative);
  border: 1px solid var(--theme-border-decorative);
  border-radius: 14px;
  max-width: 720px;
  padding: 17px;
}
.file-evaluation__upload-head { align-items: center; display: flex; gap: 12px; margin-bottom: 14px; }
.file-evaluation__upload-head > span {
  align-items: center;
  background: var(--theme-banner-background);
  border-radius: 10px;
  display: flex;
  flex: 0 0 auto;
  height: 42px;
  justify-content: center;
  width: 42px;
}
.file-evaluation__upload-head > span::v-deep .v-icon {
  color: var(--theme-banner-text) !important;
}
.file-evaluation__upload-head strong { color: #172033; display: block; font-size: 14px; }
.file-evaluation__upload-head small { color: #667085; display: block; font-size: 12px; margin-top: 2px; }
.file-evaluation__input { margin: 0 !important; padding: 0 !important; }
.file-evaluation__input::v-deep .v-input__slot { background: #fff; margin-bottom: 3px; min-height: 46px; }
.file-evaluation__hint { color: #7a8592; font-size: 11px; }
.file-evaluation__error { color: #b93131; display: block; font-size: 12px; margin-top: 5px; }
.file-evaluation__success {
  align-items: center;
  background: #f1faf6;
  border: 1px solid #cfe8dc;
  border-radius: 14px;
  display: flex;
  gap: 12px;
  max-width: 720px;
  padding: 16px 17px;
}
.file-evaluation__success > span {
  align-items: center;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex: 0 0 auto;
  height: 42px;
  justify-content: center;
  width: 42px;
}
.file-evaluation__success strong { color: #172033; display: block; font-size: 14px; }
.file-evaluation__success small { color: #52665e; display: block; font-size: 12px; margin-top: 3px; }
.file-evaluation__submit {
  align-items: center;
  background: var(--theme-header-background);
  border: 0;
  border-radius: 10px;
  box-shadow: 0 5px 13px var(--theme-border-decorative);
  color: var(--theme-header-text);
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 800;
  gap: 8px;
  margin-top: 16px;
  min-height: 44px;
  padding: 10px 18px;
}
.file-evaluation__submit:hover:not(:disabled) { filter: brightness(.9); }
.file-evaluation__submit::v-deep .v-icon { color: currentColor !important; }
.file-evaluation__submit:disabled { box-shadow: none; cursor: not-allowed; opacity: .45; }
@media (max-width: 600px) {
  .file-evaluation__task { font-size: 16px; }
  .file-evaluation__upload { padding: 14px; }
  .file-evaluation__submit { justify-content: center; width: 100%; }
}
</style>
